import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ExclusiveRates from "./exclusiveRate";
import { Remarkable } from "remarkable";

const markdown = new Remarkable();

const getServices = rates => {
  return rates.reduce((obj, data) => {
    !obj[data.type] && (obj[data.type] = []);
    obj[data.type].push(data);
    return obj;
  }, {});
};

const ConsultationRates = ({ content }) => {
  const { title, subtitle, description, rates = [], caption } = content;
  const serviceTypes = getServices(rates);
  return (
    <>
      <div className="existingUsers">
        <div className="left">
          <div className="content">
            <h3>{title}</h3>
            <h2>{subtitle}</h2>
            <p dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
          </div>
        </div>
        <div>&nbsp;</div>
      </div>
      <div className="ratesTitle" dangerouslySetInnerHTML={{ __html: markdown.render(caption) }} />
      <div className="serviceTabs">
        <Tabs>
          <TabList>
            {Object.keys(serviceTypes).map((type, i) => (
              <Tab key={i}>{type}</Tab>
            ))}
          </TabList>
          {Object.keys(serviceTypes).map((type, i) => {
            return (
              <TabPanel key={i}>
                <div className="exclusiveRates">
                  <div className="rates">
                    {serviceTypes[type].map((service, serviceIndex) => (
                      <ExclusiveRates key={serviceIndex} content={service} />
                    ))}
                  </div>
                </div>
              </TabPanel>
            );
          })}
        </Tabs>
      </div>
    </>
  );
};

export default ConsultationRates;
